import React, { Component } from 'react';
import _ from 'lodash';

class Answer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			label: '',
			value: ''
		};
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleParentStateCallback = this.handleParentStateCallback.bind(this);
	}
	handleEmptyValues() {
		const stateValues = _.valuesIn(this.state);
		const emptyValues = _.some(stateValues, value => value === '');
		return emptyValues;
	}
	btnMode() {
		return this.handleEmptyValues()
			? 'btn btn-secondary btn-sm disabled'
			: 'btn btn-secondary btn-sm';
	}
	handleOnChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	handleParentStateCallback() {
		if (this.handleEmptyValues()) {
			return null;
		}
		this.props.parentStateCallback(this.state);
		this.setState({
			label: '',
			value: ''
		});
	}
	render() {
		return (
			<React.Fragment>
				<div className="row alert alert-dark">
					<div className="col-sm-6">
						<div className="form-group">
							<label>Respuesta</label>
							<input
								type="text"
								name="label"
								value={this.state.label}
								onChange={this.handleOnChange}
								className="form-control"
							/>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="form-group">
							<label>Valor</label>
							<input
								type="text"
								name="value"
								value={this.state.value}
								onChange={this.handleOnChange}
								className="form-control"
							/>
						</div>
					</div>
				</div>

				<button
					onClick={this.handleParentStateCallback}
					className={this.btnMode()}
				>
					Agregar respuesta
				</button>

				<br />
			</React.Fragment>
		);
	}
}

export default Answer;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/FieldCollection/SingleMultipleAnswer.js